/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgCameraOff(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <g>
        <path
          fill='currentColor'
          fillRule='evenodd'
          d='M.47.47a.75.75 0 011.06 0l8.71 8.71a.629.629 0 01.02.02l5.54 5.54a.758.758 0 01.02.02l7.71 7.71a.75.75 0 11-1.06 1.06l-1.78-1.78H3A2.75 2.75 0 01.25 19V8A2.75 2.75 0 013 5.25h1.19L.47 1.53a.75.75 0 010-1.06zm5.22 6.28H3A1.25 1.25 0 001.75 8v11A1.25 1.25 0 003 20.25h16.19l-3.862-3.86a4.751 4.751 0 01-6.717-6.718L5.689 6.75zm3.982 3.982a3.25 3.25 0 004.596 4.596l-4.596-4.596zM8.309 2.71A.75.75 0 019 2.25h6a.75.75 0 01.624.334l1.777 2.666H21A2.75 2.75 0 0123.75 8v9.34a.75.75 0 01-1.287.524l-14-14.34a.75.75 0 01-.154-.815zM10.78 3.75l11.47 11.748V8A1.25 1.25 0 0021 6.75h-4a.75.75 0 01-.624-.334L14.599 3.75H10.78z'
        />
      </g>
      <defs>
        <clipPath id='camera-off_svg__clip0_126_10422'>
          <path fill='#fff' d='M0 0h24v24H0z' />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgCameraOff;
